import React from 'react';
import Image from 'next/image';
import logoImage from './image/ChatGPT Image Dec 29, 2025, 02_44_05 PM.png';

interface LogoProps {
  className?: string;
  size?: number;
  variant?: 'default' | 'faded';
}

export function Logo({ className = '', size = 120, variant = 'default' }: LogoProps) {
  const opacity = variant === 'faded' ? 0.1 : 1;
  
  return (
    <div 
      className={`relative overflow-hidden ${className}`} 
      style={{ 
        width: size, 
        height: size, 
        opacity,
        borderRadius: '50%',
        backgroundColor: 'transparent'
      }}
    >
      <div 
        className="absolute inset-0 rounded-full"
        style={{
          clipPath: 'circle(50% at 50% 50%)',
          WebkitClipPath: 'circle(50% at 50% 50%)',
        }}
      >
        <Image
          src={logoImage}
          alt="Shaanxi Jia'an Automobile Service Group Logo"
          width={size}
          height={size}
          className="drop-shadow-lg object-cover"
          style={{ 
            opacity,
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
          priority
        />
      </div>
    </div>
  );
}

export function LogoIcon({ className = '', size = 40 }: { className?: string; size?: number }) {
  return (
    <div 
      className={`relative ${className}`} 
      style={{ 
        width: size, 
        height: size,
        borderRadius: '50%',
        overflow: 'hidden',
        display: 'inline-block',
        flexShrink: 0,
        backgroundColor: 'oklch(0.85 0.15 90)'
      }}
    >
      <Image
        src={logoImage}
        alt="Logo"
        width={size}
        height={size}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '50%',
          mixBlendMode: 'multiply'
        }}
        priority
      />
    </div>
  );
}

